import * as React from "react";

export const CloseIcon: React.FC<{
  className?: string;
  size?: number;
  color?: string;
}> = ({ className, size = 24, color = "currentColor" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    className={className}
  >
    <path
      d="M18 6L6 18M6 6l12 12"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);